import { CoreMenu, Header } from '@components'
import cn from 'classnames'
import styles from './AppLayout.module.scss'

const AppLayout = ({ menuVisible, children, ref }) => {
  return (
    <div className={cn(styles['app-layout'])} ref={ref}>
      {menuVisible ? <CoreMenu /> : null}

      <div className={styles['app-wrapper']}>
        {menuVisible ? <Header /> : null}

        <div className={styles['app-container']}>{children}</div>
      </div>
    </div>
  )
}

export default AppLayout
